/**
 * 投诉请求接口
 * @author 王振宇
 * @since 2022-07-21
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_COMPLAIN_PAGE_LIST: function GET_COMPLAIN_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/complain/getPageList',
        method: 'get',
        params: data
      });
    },
    GET_COMPLAIN_LIST: function GET_COMPLAIN_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/complain/getList',
        method: 'get',
        params: data
      });
    },
    GET_COMPLAIN_INFO: function GET_COMPLAIN_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/complain/info',
        method: 'get',
        params: data
      });
    },
    SAVE_COMPLAIN: function SAVE_COMPLAIN() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/complain/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_COMPLAIN: function UPDATE_COMPLAIN() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/complain/update',
        method: 'put',
        data: data
      });
    },
    DELETE_COMPLAIN: function DELETE_COMPLAIN() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/complain/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_COMPLAIN: function DELETE_BATCH_COMPLAIN() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/complain/deleteBatch',
        method: 'delete',
        data: data
      });
    }
  };
});